import { apiRequest } from './api'

const clearanceService = {
  create: async (payload) => {
    try {
      const response = await apiRequest('/clearance-requests', { method: 'POST', body: payload })
      return { success: true, data: response.data?.request || response.request || response, message: 'Clearance request created' }
    } catch (error) {
      return { success: false, error: error.message || String(error), message: 'Failed to create clearance request' }
    }
  },
  update: async (requestId, payload) => {
  try {
    const response = await apiRequest(`/clearance-requests/${requestId}`, {
      method: 'PUT',
      body: payload
    })
    return { success: true, data: response.data?.request || response.request || response, message: 'Clearance request updated' }
  } catch (error) {
    return { success: false, error: error.message, message: 'Failed to update clearance request' }
  }
},
   // NEW: Get presigned URL for document upload
  presignDocument: async (requestId, payload) => {
    try {
      const response = await apiRequest(`/clearance-requests/${requestId}/documents/presign`, {
        method: 'POST',
        body: payload
      })
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.message }
    }
  },

  // NEW: Confirm document upload (mark as UPLOADED)
  confirmDocumentUpload: async (requestId, documentId) => {
    try {
      const response = await apiRequest(`/clearance-requests/${requestId}/documents/${documentId}/confirm`, {
        method: 'POST',
        body: {}
      })
      return { success: true, data: response.data }
    } catch (error) {
      return { success: false, error: error.message }
    }
  },
  getAllClearanceRequests: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams()
      
      if (filters.requestType) {
        queryParams.append('requestType', filters.requestType)
      }
      if (filters.status) {
        queryParams.append('status', filters.status)
      }
      if (filters.city) {
        queryParams.append('city', filters.city)
      }
      if (filters.containerType) {
        queryParams.append('containerType', filters.containerType)
      }
      if (filters.limit) {
        queryParams.append('limit', filters.limit)
      }
      if (filters.offset) {
        queryParams.append('offset', filters.offset)
      }

      const endpoint = `/clearance-requests${queryParams.toString() ? `?${queryParams.toString()}` : ''}`
      
      const response = await apiRequest(endpoint, {
        method: 'GET',
      })

      return {
        success: true,
        data: response.data?.requests || response.requests || [],
        count: response.data?.count || 0,
        message: 'Clearance requests fetched successfully',
      }
    } catch (error) {
      return {
        success: false,
        error: error.message,
        message: 'Failed to fetch clearance requests',
        data: [],
        count: 0,
      }
    }
  },

  // Get single clearance request by ID
  getClearanceRequestById: async (requestId) => {
    try {
      const response = await apiRequest(`/clearance-requests/${requestId}`, {
        method: 'GET',
      })

      return {
        success: true,
        data: response.data?.request || response.request || response,
        message: 'Clearance request fetched successfully',
      }
    } catch (error) {
      return {
        success: false,
        error: error.message,
        message: 'Failed to fetch clearance request',
        data: null,
      }
    }
  },

  // Update clearance request status (Admin only)
  updateClearanceStatus: async (requestId, status, reviewNotes = null) => {
    try {
      const response = await apiRequest(`/clearance-requests/${requestId}/status`, {
        method: 'PUT',
        body: {
          status,
          reviewNotes,
        },
      })

      return {
        success: true,
        data: response.data?.request || response.request || response,
        message: 'Clearance request status updated successfully',
      }
    } catch (error) {
      return {
        success: false,
        error: error.message,
        message: 'Failed to update clearance request status',
      }
    }
  },

  // Delete clearance request (Admin only)
  deleteClearanceRequest: async (requestId) => {
    try {
      const response = await apiRequest(`/clearance-requests/${requestId}`, {
        method: 'DELETE',
      })

      return {
        success: true,
        data: response,
        message: response.message || 'Clearance request deleted successfully',
      }
    } catch (error) {
      return {
        success: false,
        error: error.message,
        message: 'Failed to delete clearance request',
      }
    }
  },
}

export { clearanceService }

